import { render } from "./OrganizationAssignedRights.vue?vue&type=template&id=2090da49&scoped=true"
import script from "./OrganizationAssignedRights.vue?vue&type=script&lang=js"
export * from "./OrganizationAssignedRights.vue?vue&type=script&lang=js"

import "./OrganizationAssignedRights.vue?vue&type=style&index=0&id=2090da49&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2090da49"]])

export default __exports__